import React from "react";
import { Box } from "@mui/material";
import { useRole } from "../hooks/useRole.js";

const EmptyStateMessage = ({ t, isMobile }) => {
    // 📡 Récupération du rôle au montage
    const role = useRole();
    const isAdmin = role === "admin";

  if (!isAdmin) return null;

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: isMobile ? 2 : 4,
        backgroundColor: "#e4dcd2",
        borderRadius: 2,
        marginBottom: 2,
        color: "#555",
        fontSize: isMobile ? "0.9rem" : "1rem",
        fontStyle: "italic",
        width: "85vw",
        maxWidth: isMobile ? "90%" : "auto",
        margin: "2 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      📭 {t('AddContactMsg')}
    </Box>
  );
};

export default EmptyStateMessage;
